/**
 * Analytics Service
 *
 * Tracks key user events for trial/paywall conversion flow.
 * P0: Structured console.log (visible in browser DevTools).
 * P1: Replace with Mixpanel/PostHog/Amplitude.
 */

export type AnalyticsEvent =
  | 'signup'
  | 'ig_linked'
  | 'first_carousel_generated'
  | 'paywall_shown'
  | 'checkout_clicked'
  | 'support_clicked';

export function trackEvent(
  event: AnalyticsEvent,
  properties?: Record<string, any>,
): void {
  const payload = {
    event,
    timestamp: new Date().toISOString(),
    ...properties,
  };

  // P0: Log to console (visible in browser DevTools)
  console.log('[analytics]', JSON.stringify(payload));
}
